// services/channelCodeService.ts
import { ref, Ref } from "vue";
// BjqyBjqyYyt 北京营业厅
// BjqyBjqyPt 北京区域
//LvxingshedaixiaoHZY旅行社-代销
// LvxingsheHZY 旅行社-分销
// 定义 channelCode 的类型
type ChannelCode = string;

// 获取 URL 中的参数
const getUrlParam = (paramName: string): string | null => {
  const searchParams = new URLSearchParams(window.location.search);
  return searchParams.get(paramName);
};

// 存储 channelCode 到本地缓存
const saveChannelCodeToCache = (channelCode: ChannelCode): void => {
  localStorage.setItem("channelCode", channelCode);
};

// 从缓存获取 channelCode
const getChannelCodeFromCache = (): ChannelCode | null => {
  return localStorage.getItem("channelCode");
};

// 初始化 channelCode
const initChannelCode = (): ChannelCode => {
  // 先从 URL 中获取 channelCode
  const urlChannelCode = getUrlParam("channelCode");

  if (urlChannelCode) {
    // 如果 URL 中有 channelCode，保存到缓存并返回
    saveChannelCodeToCache(urlChannelCode);
    return urlChannelCode;
  } else {
    // 从缓存中获取 channelCode
    const cacheChannelCode = getChannelCodeFromCache();

    if (cacheChannelCode) {
      // 如果缓存中有值，直接返回
      return cacheChannelCode;
    } else {
      // 否则使用默认值并保存到缓存
      const defaultChannelCode = "BjqyBjqyPt";
      saveChannelCodeToCache(defaultChannelCode);
      return defaultChannelCode;
    }
  }
};

// 创建响应式的 channelCode 变量
const channelCode: Ref<ChannelCode> = ref(initChannelCode());

// 更新 channelCode 并保存到缓存
const updateChannelCode = (newChannelCode: ChannelCode): void => {
  saveChannelCodeToCache(newChannelCode);
};

// 移除 URL 中的 channelCode 参数（如果存在）
const removeChannelCodeFromUrl = (): void => {
  if (getUrlParam("channelCode")) {
    const url = new URL(window.location.href);
    url.searchParams.delete("channelCode");
    history.replaceState(null, "", url.toString());
  }
};

// code参数相关处理
const saveCodeToCache = (code: string): void => {
  localStorage.setItem("validCode", code);
};

const getCodeFromCache = (): string | null => {
  return localStorage.getItem("validCode");
};

const clearCodeCache = (): void => {
  localStorage.removeItem("validCode");
};

// 检查是否有有效的code（URL或缓存中）
const hasValidCode = (): boolean => {
  // 先从URL获取
  const urlCode = getUrlParam("channelCode");
  if (urlCode) {
    saveCodeToCache(urlCode); // 存入缓存
    return true;
  }
  
  // 再从缓存获取
  return getCodeFromCache() !== null;
};

// 移除URL中的code参数
const removeCodeFromUrl = (): void => {
  if (getUrlParam("channelCode")) {
    const url = new URL(window.location.href);
    url.searchParams.delete("channelCode");
    history.replaceState(null, "", url.toString());
  }
};

export {
  channelCode,
  updateChannelCode,
  removeChannelCodeFromUrl,
  initChannelCode,
  getChannelCodeFromCache,
  hasValidCode,
  clearCodeCache,
  removeCodeFromUrl
};
